export const BRAND = {
  // E-learning color palette
  navy: "#1D314D",      // Deep navy (hero gradient start)
  navyDark: "#0f172a",  // Very dark navy (gradient end)
  navy2: "#2E4663",     // Secondary navy (gradient middle)
  silver: "#C9CED6",
  graphite: "#4A5568",
  goldStart: "#C9A033",
  goldEnd: "#EAD67C",
  gold: "#CEAB65",      // Accent gold
  iconBg: "#1f2b3f",    // Icon background
} as const;
